import { Container } from 'react-bootstrap';
import styles from './CourseBox.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CertificateIcon } from '../../../assets/svg/certificate.svg';

const CourseBoxComponent = ({ course }) => {
  const { t } = useTranslation();

  return (
    <Container
      as={Link}
      className={`${styles.courseBox} gradient-border`}
      to={`/course/${course.id}`}
    >
      <div className={'d-flex mb-4'}>
        <h2 className={`mb-0 ${styles.cropText2} ${styles.courseTitle}`}>
          {course.name}
        </h2>
        <div className={`d-flex flex-column ml-auto align-items-center ${styles.courseStats}`}>
          {/* TODO: Controllare se esiste il certificato */}
          {course.withCertificate && (
            <div className={styles.certificationChip}>
              <CertificateIcon className={styles.certificationIcon} aria-hidden="true" />
              <span>{t('course.labels.withCertificate')}</span>
            </div>
          )}
          <div className={`mt-auto ${styles.unitsLength}`}>
            <b>{course.chapters.flatMap((chapter) => chapter.units).length}</b> Video
          </div>
        </div>
      </div>
      {!!course.description && (
        <div className={styles.cropText3}>
          {course.description.map((segment, i) => (
            <p className={'m-0'} key={i.toString()}>
              {segment}
            </p>
          ))}
        </div>
      )}
      {!!course.header && <div className={styles.courseImage} style={{ backgroundImage: `url(${course.header})` }} />}
    </Container>
  );
};

export { CourseBoxComponent as CourseBox };
